export default {
      id: "ind-red-recurring-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#ind-red-recurring",
      toString: function () {
        return this.url;
      }
    }